import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { SliceZone } from '../components/SliceZone';

function CurrencyProductPage(props) {
  const data = props.data.prismicCurrencyProductPage.data;

  return (
    <Layout headerCtaLabel={data.header_cta_label.text} {...props}>
      <SEO title={data.tab_title ? data.tab_title.text : ''} />
      <SliceZone allSlices={data.body} />
    </Layout>
  );
}

export default CurrencyProductPage;

export const pageQuery = graphql`
  query CurrencyProductPageBySlug($uid:String!) {
    prismicCurrencyProductPage(uid:{ eq:$uid }) {
      uid
      dataString
      data {
        tab_title {
          text
        }
        header_cta_label {
          text
        }
        body {
          ... on PrismicCurrencyProductPageBodyCurrencyHero {
            id
            slice_type
            primary {
              icon {
                url
              }
              currency_name {
                text
              }
              headline {
                text
              }
              primary_cta {
                text
              }
              primary_cta_link {
                url
              }
              secondary_cta {
                text
              }
              secondary_cta_link {
                url
              }
              market_cap {
                text
              }
              volume {
                text
              }
              proof_of_funds {
                text
              }
              proof_of_funds_link {
                url
              }
            }
          }
          ... on PrismicCurrencyProductPageBodySectionHeader {
            id
            slice_type
            primary {
              tagline {
                text
              }
              description {
                text
              }
              background_color
            }
          }
          ... on PrismicCurrencyProductPageBodyFeatureBoxSection {
            id
            slice_type
            items {
              icon {
                url
              }
              name {
                text
              }
              description {
                text
              }
            }
          }
          ... on PrismicCurrencyProductPageBodyHomepagePor {
            id
            slice_type
            primary {
              title {
                text
              }
              desc {
                text
              }
              subdesc {
                text
              }
            }
          }
          ... on PrismicCurrencyProductPageBodyInfoBoxSection {
            id
            slice_type
            items {
              icon {
                url
              }
              name {
                text
              }
              description {
                text
              }
              link {
                url
              }
            }
          }
          ... on PrismicCurrencyProductPageBodyPartnerCarousel {
            id
            slice_type
            items {
              image {
                url
              }
              headline {
                text
              }
              description {
                text
              }
              cta_label {
                text
              }
              cta_link {
                url
              }
            }
          }
          ... on PrismicCurrencyProductPageBodyTokenInfoSection {
            id
            slice_type
            primary {
              token_chain {
                text
              }
              sub_title {
                text
              }
              desc {
                text
              }
              attr {
                text
              }
            }
            items {
              token_type {
                text
              }
              info_icon {
                url
              }
              token_link {
                url
              }
              token_address {
                text
              }
            }
          }
          ... on PrismicCurrencyProductPageBodyExchangePartnersSection {
            id
            slice_type
            primary {
              cta_headline {
                text
              }
              cta_description {
                text
              }
              primary_cta_label {
                text
              }
              primary_cta_link {
                url
              }
              secondary_cta_label {
                text
              }
              secondary_cta_link {
                url
              }
              list_headline {
                text
              }
            }
            items {
              icon {
                url
              }
              link {
                url
              }
            }
          }
          ... on PrismicCurrencyProductPageBodyContactBox {
            id
            slice_type
            primary {
              headline {
                text
              }
              description {
                text
              }
              input_placeholder {
                text
              }
            }
          }
        }
      }
    }
  }
`;
